export const handleImage = image => {
	if (!image.includes("https") || !image.includes("http")) {
		return `${process.env.REACT_APP_MAIN_URL}${image}`;
	}
	return image;
};
